export default __webpack_public_path__ + "static/media/fr6.784f9c49.webp";